import { LineResultBuilder } from "ags/integration/builders/results/line-result-builder";
import { AgsWin, AgsWinTypes } from "ags/integration/schema/ags-spin-response-schema";

export class ThemeLineResultBuilder extends LineResultBuilder {
    public override filter(response: AgsWin): boolean {
        const isLineOrJackpotWin = response.winType === AgsWinTypes.LINES || response.winType === AgsWinTypes.JACKPOT;
        return isLineOrJackpotWin && response.lineNumber !== undefined;
    }
}
